// Manage flow of all booker authorization screens here
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountInfo from './AccountInfo';
import Authorize from './Authorize';
import SetupSuccess from './SetupSuccess';
import StaffLogin from './StaffLogin';
import Configure from './Configure';
import { event } from 'react-ga';

export default class ZenotiSetup extends Component {
  constructor() {
    super();

    this.state = {
      isAccountInfoSaved: false,
      isSetupComplete: false,
      staffCredSaved:false,
      authorized:false,
      isLocationSelected:false,
      isConfigureSetup:false,
      configureData:{}
    };

    this.handleBackAction = this.handleBackAction.bind(this);
    this.staffCredIsSaved = this.staffCredIsSaved.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { softwares: prevSoftwares } = this.props;
    const { softwares: newSoftwares, zenotiAuthType } = nextProps;
    const newState = {};

    // isSavingZenotiAccountInfo: false,
    // isZenotiAccountInfoSaveSuccess: true,
    // isZenotiAccountInfoSaveFail: false,
    // if (prevSoftwares.isZenotiAccountInfoSaveSuccess) {
    //   newState.isAccountInfoSaved = true;
    // }

    if (
      prevSoftwares.isSavingZenotiAccountInfo &&
      !newSoftwares.isSavingZenotiAccountInfo &&
      newSoftwares.isZenotiAccountInfoSaveSuccess
    ) {
      newState.isAccountInfoSaved = true;
    }

    if (!prevSoftwares.isZenotiAutorized && newSoftwares.isZenotiAutorized) {
      newState.isSetupComplete = true;
    }

    if(!prevSoftwares.zenotiStaffCredLogin && newSoftwares.zenotiStaffCredLogin){
      newState.staffCredSaved = true
    }
    if(!prevSoftwares.isZenotiAutorization && newSoftwares.isZenotiAutorization){
      newState.authorized = true
    }

    console.log('prevSoftwares',prevSoftwares);
    console.log('newSoftwares',newSoftwares);

    if (Object.keys(newState).length) {
      this.setState(newState);
    }
  }

  handleBackAction(screen) {
    if (screen === 'accountinfo') {
      this.setState({
        isAccountInfoSaved: false,
        isConfigureSetup:false,
        staffCredSaved:false,
        isSetupComplete:false,
      });
    }

    if (screen === 'configure') {
      this.setState({
        isAccountInfoSaved: true,
        isConfigureSetup:false,
        staffCredSaved:false,
        isSetupComplete:false,
      });
    }

    if (screen === 'staffcred') {
      this.setState({
        isAccountInfoSaved: true,
        isConfigureSetup:true,
        staffCredSaved:false,
        isSetupComplete:false,
      });
    }
  }

  saveConfigureData=(data)=>{
    this.setState({
      isConfigureSetup:true,
      configureData:data
    });
    this.props.onZenotiConfigureSetup();
  }

  staffCredIsSaved(){
    this.setState({
      staffCredSaved:true
    });
  }
  onSuccessClick=(event)=>{
            console.log("Ok Button Pressed On Setup Success page");
            event.preventDefault();
            this.props.getBookingSoftware();

            // Redirect to summary screen
            this.props.router.push('/app/setup');
  }
  render() {
    const { router, zenotiAuthType, onzenotiAuthTypeChange} = this.props;
    const { isConfigureSetup, isAccountInfoSaved, isSetupComplete, staffCredSaved ,authorized , configureData} = this.state;
    console.log("State",this.state, router);
    if (isSetupComplete) {
      // Show setup success screen
      return (
        <SetupSuccess
          onDone={this.onSuccessClick}
          {...this.props}
        />
      );
    }

    if(staffCredSaved){
      return (
        <Authorize
          onBack={() => {
            this.handleBackAction('staffcred');
          }}
          {...this.props}
          configureData={configureData}
        />
      );
    }
    
    if (isConfigureSetup) {
      return (
        <StaffLogin
          onBack={() => {
            this.handleBackAction('configure');
          }}
          staffCredIsSaved = {this.staffCredIsSaved}
          {...this.props}
        />
      );
    }

    if (isAccountInfoSaved) {
      if(!this.props.softwares.brand){
      return (
        <Configure
          onBack={() => {
            this.handleBackAction('accountinfo');
          }}
          saveConfigureData={this.saveConfigureData}
          {...this.props}
        />
      );
     }
     else{
      return (
        <StaffLogin
          onBack={() => {
            this.handleBackAction('accountinfo');
          }}
          staffCredIsSaved = {this.staffCredIsSaved}
          {...this.props}
        />
      );
     }
    }

    return <AccountInfo {...this.props} zenotiAuthType={zenotiAuthType} onzenotiAuthTypeChange={onzenotiAuthTypeChange}/>;
  }
}

ZenotiSetup.propTypes = {
  getBookingSoftware: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  router: PropTypes.shape().isRequired,
};
